import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Loader from "react-loader-spinner";
import { getServiceInvoice } from "../store/api/Services";
import { Table } from "react-bootstrap";
const ServiceInvoice = () => {
    const history = useHistory();
    const { serviceID, serviceType } = useParams();
    const dispatch = useDispatch();
    const invoice = useSelector(state => state.service.serviceInvoice);
    const isLoading = useSelector(state => state.loading?.isLoading);
    useEffect(async () => {
        dispatch(getServiceInvoice(serviceType, serviceID));
    }, []);
    function printInvoice(e) {
        history.push({
            pathname: `/PrintViewer/ServiceInvoice/${e.ctrlKey}`,
            state: {
                dataUrl:`ReceptionTasksApi/GetServiceInvoice?serviceID=${serviceID}&serviceType=${serviceType}`,
                method: "get"
            }
        });
    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    return (
        <div className="container-fluid mt-4">
            {!invoice && <Loader type="BallTriangle" color="red" height={80} width={80} />}
            {invoice &&
                <div className="card">
                    <div className="card-header headerStyle">فاکتور خدمات</div>
                    <div className="card-body bodyStyle">
                        <table className="tableStyle" style={{ marginBottom: "12px" }}>
                            <tbody>
                                <tr>
                                    <td className="columnForPrint"><span>شماره فاکتور: </span><span>{invoice.InvoiceNumber}</span></td>
                                    <td className="columnForPrint"><span>تاریخ فاکتور: </span><span>{invoice.InvoiceDate}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>نام محصول: </span><span>{invoice.ProductName}</span></td>
                                    <td className="columnForPrint"><span>مدل محصول: </span><span>{invoice.ProductModel}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <Table responsive={true}>
                            <thead>
                                <tr>
                                <th style={{display:"none"}}></th>
                                <th>کدکالا/خدمت</th>
                                <th>شــرح</th>
                                <th>مدل کالا</th>
                                <th>تعداد</th>
                                <th>قیمت واحد</th>
                                <th>قیمت کل</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoice && invoice.details &&
                                    invoice.details.map((item, i) => {
                                        return <tr className="resultTableRow" key={i}>
                                            <td  style={{display:"none"}}></td>
                                            <td className="columnForPrint">{item.ProductCode}</td>
                                            <td className="columnForPrint">{item.ProductName}</td>
                                            <td className="columnForPrint">{item.ProductModel}</td>
                                            <td className="columnForPrint">{item.ProductCount}</td>
                                            <td className="columnForPrint">{item.UnitPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                            <td className="columnForPrint">{item.TotalPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                        <table className="tableStyle mt-2">
                            <tbody>
                                <tr>
                                    <td className="columnForPrint"><span>تخفیف: </span><span>{invoice.Discount.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>مالیات: </span><span>{invoice.Tax.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></td>
                                </tr>
                                <tr>
                                    <td className="columnForPrint"><span>جمع کل: </span><span>{invoice.TotalCost.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-success" style={{fontSize:"12px"}} onClick={printInvoice}>چاپ فاکتور</button>
                        </div>
                </div>
            }

        </div>
    );
}
export default ServiceInvoice;